/* eslint-disable import/prefer-default-export */
import React from 'react'

const MenuArrowIcon = () => (
  <svg width="14" height="21" viewBox="0 0 14 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.38184 1.08618L12.3439 10.0862L1.38184 19.0862" stroke="#787878" strokeOpacity="0.6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default MenuArrowIcon
